import { Box, Stack, Typography } from '@mui/material';
import React, { useState, useEffect, useCallback } from 'react';
import GlobalPyramidChart from './GlobalPyramidChart';
import CustomSmallSelect from '../../custom-input/CustomSmallSelect';
import { onGetFirstTimeAndFollowUpPatients, onGetCurrentPeriod } from '../../../pages/Programs/AnalyticsBusinessProgramPage/analytics_utils';

const GlobalPyramidGroup = ({
    period,
    appointments,
    program_users,
    locations,
}) => {

    console.log("Mis lcoation", locations)

    const [global_data, setGlobalData] = useState()
    const [selected, setSelected] = useState(-1)

    const onGetLocalData = useCallback(() => {
        
        const validPeriod = onGetCurrentPeriod(period)
        console.log(locations)

        const {follow_up_users, first_time_users, valid_period_appointments, scheduled_appointments} = onGetFirstTimeAndFollowUpPatients(program_users, appointments, validPeriod)
        //console.log(first_time_users)

        if(selected === -1 ){
            setGlobalData({
                total:program_users.length,
                first_time_users:first_time_users.length,
                follow_up_users:follow_up_users.length,
                pending_users: program_users.length - first_time_users.length - follow_up_users.length -scheduled_appointments.length,
                scheduled_appointments: scheduled_appointments.length
            })
        }else{

            let lc_program_users = program_users.filter(el => el.user_client_location_id === selected)
            let lc_first_time_users = first_time_users.filter(el => el.client_location_id === selected)
            let lc_follow_up_users = follow_up_users.filter(el => el.client_location_id === selected)
            let lc_scheduled_appointments = scheduled_appointments.filter(el => el.client_location_id === selected)

            setGlobalData({
                total:lc_program_users.length,
                first_time_users:lc_first_time_users.length,
                follow_up_users:lc_follow_up_users.length,
                pending_users: lc_program_users.length - lc_first_time_users.length - lc_follow_up_users.length -lc_scheduled_appointments.length,
                scheduled_appointments: lc_scheduled_appointments.length
            })
        }

        

    },[period, appointments, program_users, locations, selected])

    useEffect(() => {
        onGetLocalData()
    }, [selected])

    const _locations = [
        {id_client_location:-1, name:'Todos los sitios'},
        ...locations
    ]
    console.log(_locations)
    console.log(_locations.length)

    const selected_location = _locations.find(el => el.id_client_location === selected)


    return ( 
        <Box>
            <Stack direction='row'>
                <Typography variant='h5' sx={{flex:1}}>
                    Conteo Global - {selected_location?.name}
                </Typography>
                <Stack direction='row' justifyContent='flex-end'>
                    <CustomSmallSelect label='Sitio' value={selected} onChange={(e) => setSelected(parseInt(e.target.value))}>
                        {_locations.map((location) => (
                            <option key={location.id_client_location} value={location.id_client_location}>
                                {location.name}
                            </option>
                        ))}
                    </CustomSmallSelect>
                    
                </Stack>
                
                
            </Stack>
            <Box sx={{
                maxWidth:800,
                margin:'auto',
                py:2
            }}>
                <GlobalPyramidChart
                    total_users={global_data?.total}
                    initial_appointment_users={global_data?.first_time_users}
                    follow_up_appointment_users={global_data?.follow_up_users}
                    scheduled_appointment_users={global_data?.scheduled_appointments}
                    pending_users={global_data?.pending_users}
                    disabled_users={0}
                />
            </Box>
            
        </Box>
     );
}
 
export default GlobalPyramidGroup;